<!-- <div
  class="main-loading-container"
  [ngClass]="{ fadeOut: showContent, 'dark-theme': darkMode }"
  *ngIf="showMainLoader"
>
  <div class="main-loading"><div class="loader"></div></div>
</div> -->

<!-- <div *ngIf="showContent"> -->
<router-outlet></router-outlet>
<app-full-screen-preview></app-full-screen-preview>
<!-- </div> -->
